/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 */

export const getPublicAchievementEarlyRequestRpc = {
  serviceName: 'com.hubspot.credentials.rpc.AchievementPublicRpc',
  rpcName: 'getPublicAchievement',
  auth: 'external',
  fingerprint: 'IlAHR304DaWXUBBBFH9CUJEAXm2HbnMQ',
  earlyRequest: true,
  na1Only: false,
  isStreaming: false
};
export const getPublicAchievementV2EarlyRequestRpc = {
  serviceName: 'com.hubspot.credentials.rpc.AchievementPublicRpc',
  rpcName: 'getPublicAchievementV2',
  auth: 'external',
  fingerprint: 'IlAHR304DaUG1gr2q5kqppEAXm2HbnMQ',
  earlyRequest: true,
  na1Only: false,
  isStreaming: false
};